module.exports = __webpack_public_path__ + "img/asd.17487213.svg";